import { render, staticRenderFns } from "./TwoColumn.vue?vue&type=template&id=c1e212be&scoped=true&"
import script from "./TwoColumn.vue?vue&type=script&lang=js&"
export * from "./TwoColumn.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumn.vue?vue&type=style&index=0&id=c1e212be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e212be",
  null
  
)

export default component.exports